import { ENVIRONMENTS, type Environment } from "@csbi/contracts"

export const ENV_LABELS: Record<Environment, string> = {
  production: "Production",
  staging: "Staging",
  dev: "Dev",
}

export const ENV_ORDER: readonly Environment[] = ["production", "staging", "dev"]

/** Rank used for sorting. An unknown environment sorts last rather than first — it must not pass for production */
export const envRank = (env: string | null): number => {
  const i = ENV_ORDER.indexOf(env as Environment)
  return i === -1 ? ENV_ORDER.length : i
}

export const envLabel = (env: string | null): string =>
  env == null ? "Unknown" : (ENV_LABELS[env as Environment] ?? env)

export const KNOWN_ENVIRONMENTS = ENVIRONMENTS
